import { Flex, Switch, Text } from '@mantine/core';

type SwitchSelectorProps = {
	name: string;
	description?: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
};

export const SwitchSelector = ({ name, description, checked, onChange }: SwitchSelectorProps) => (
	<Flex align="center" justify="space-between" gap={16}>
		<Flex direction="column">
			<Text fz={16} fw={600} lh="20px">
				{name}
			</Text>
			<Text c="dimmed" fz={14} fw={500} lh="18px">
				{description}
			</Text>
		</Flex>
		<Switch
			size="lg"
			checked={checked}
			onChange={(event) => onChange(event.currentTarget.checked)}
		/>
	</Flex>
);
